import type { Filter } from './FilterContext';
import { FilterCondition } from 'framework/types';
import { LoadingParams } from '../ListContext';

export const getFilterValues = (filter: LoadingParams['filter'], source: string): string[] =>
  filter?.[source]?.[FilterCondition.IN] ||
  (filter?.[source]?.[FilterCondition.EQ] ? [filter?.[source]?.[FilterCondition.EQ]] : []);

export const getFilterValue = <T = any>(
  filter: LoadingParams['filter'],
  source: string,
  condition: FilterCondition = FilterCondition.EQ,
): T | undefined => filter?.[source]?.[condition];

export const replaceFilterCondition = (
  filter: LoadingParams['filter'],
  source: string,
  targetCondition: FilterCondition,
  targetSource = source,
  sourceCondition: FilterCondition = FilterCondition.EQ,
  mapValue?: (value: unknown) => unknown,
): Filter | undefined => {
  const value = getFilterValue(filter, source, sourceCondition);

  if (!filter || value === undefined || value === null || value === '') {
    return filter;
  }

  const normalizedValue = mapValue ? mapValue(value) : value;
  const nextFilter = { ...filter };

  delete nextFilter[source];

  nextFilter[targetSource] = {
    [targetCondition]:
      targetCondition === FilterCondition.IN && !Array.isArray(normalizedValue) ? [normalizedValue] : normalizedValue,
  };

  return nextFilter;
};
